import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import PasswordsPrintButton from '@app/components/shared/PasswordsPrintButton'
import PasswordsDownloadButton from '@app/components/shared/PasswordsDownloadButton'
import SharePasswordsButton from '@app/components/shared/SharePasswordsButton'
import ParentInviteLink from '@app/components/shared/instructions/ParentInviteLink'

import _ from 'lodash'

import SVG from 'react-inlinesvg'
import printIcon from '@icons/print/primary'
import shareIcon from '@icons/share/primary'
import downloadIcon from '@icons/download/primary'
import statisticsIcon from '@icons/statistics/primary'
import copyLink from '@icons/copy/primary'
import addIcon from '@icons/people/primary'

const ParticipationInstructions = ({ group, callback }) => {
  const students = _.values(group.students);

  const handleCallback = (name, event) => {
    if (callback) { callback(name, event); }
    return true;
  }

  return (
    <div className="stepper">
      <div className="stepper__step">
        <div className="stepper__number">1</div>
      </div>
      <div className="grid">
        <div className="f--md">
          { I18n.t("instructions.teacher.step_1") }
        </div>
        <div>
          <ParentInviteLink
            hideDescription
            group={group}
            className="link link--icon-left f--upper word-break"
            callback={(e) => handleCallback('invite', e)}
          >
            <SVG src={copyLink} />
            { I18n.t("js.students_table.invite_link") }
          </ParentInviteLink>
        </div>
        <div>
          <a
            onClick={(e) => handleCallback('add-students', e)}
            href="javascript:void(0)"
            className="link link--icon-left f--upper word-break"
          >
            <SVG src={addIcon} />
            { I18n.t('registration.students_adding') }
          </a>
        </div>
      </div>

      <div className="stepper__step">
        <div className="stepper__number">2</div>
      </div>
      <div className="grid">
        <div className="f--md">
          { I18n.t("instructions.teacher.step_2") }
        </div>
        <div>
          <SharePasswordsButton
            students={students}
            callback={(e) => handleCallback('share-passwords', e)}
            className="link link--icon-left f--upper word-break"
          >
            <SVG src={shareIcon} />
            {I18n.t('groups.passwords.share')}
          </SharePasswordsButton>
        </div>
        <div>
          <PasswordsDownloadButton
            filename={`${group.object.name} credentials.csv`}
            students={students}
            className="link link--icon-left f--upper word-break"
          >
            <SVG src={downloadIcon} />
            {I18n.t('groups.passwords.download')}
          </PasswordsDownloadButton>
        </div>
        <div>
          <PasswordsPrintButton
            students={students}
            className="link link--icon-left f--upper word-break">

            <SVG src={printIcon} />
            { I18n.t('groups.group_header.print_logins_and_passwords') }
          </PasswordsPrintButton>
        </div>
      </div>

      <div className="stepper__step">
        <div className="stepper__number">3</div>
      </div>
      <div className="grid">
        <div className="f--md">
          { I18n.t("instructions.teacher.step_3") }
        </div>
        <div>
          <Link to={`/teachers/classes/${group.object.id}/statistics`}
                className="link link--icon-left f--upper"
          >
            <SVG src={statisticsIcon} />
            { I18n.t('teachers.show.statistic') }
          </Link>
        </div>
      </div>

      <div className="stepper__step">
        <div className="stepper__number">4</div>
      </div>
      <div className="stepper__content f--md">
        { I18n.t("instructions.teacher.step_4") }
      </div>
    </div>
  )
}

ParticipationInstructions.propTypes = {
  group: PropTypes.object.isRequired
}

export default ParticipationInstructions
